module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('ul', {
    staticClass: "menu-1"
  }, [_c('li', [_c('flags')], 1), _vm._v(" "), (_vm.isLogged) ? _c('li', {
    staticClass: "border-left-padding-left-10px"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" "), (_vm.loggedUser.username === 'admin') ? _c('b', [_vm._v(_vm._s(_vm.loggedUser.username))]) : _c('b', [_vm._v(_vm._s(_vm.loggedUser.name))]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-option-vertical"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserProfile'
      },
      "tag": "a",
      "exact": ""
    }
  }, [(_vm.loggedUser.username !== 'admin') ? _c('el-dropdown-item', [_vm._v("\n                      " + _vm._s(_vm.$t("profile")) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.loggedUser.username !== 'admin') ? _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doLogout.apply(null, arguments)
      }
    }
  }, [_c('el-dropdown-item', [_vm._v("\n                      " + _vm._s(_vm.$t("logout")) + "\n                    ")])], 1)], 1)], 1)], 1) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e55947c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/header/menuUser.vue
// module id = 968
// module chunks = 2